import styled from 'styled-components';

export const StyledButtonDouble = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 136px;
    background: ${({ theme }) => theme.veryLightPink};
    border-radius: 20px;
    height: 40px;
`